import { AxiosError } from "axios";
import { getApi, putApi } from "./apis";

export const getContractPricesApi = async (params?: {
  cropId?: number;
  year?: number;
  buyerName?: string;
}) => {
  let endpoint = `ContractPrice/contractprices`;
  
  if (params) {
    const queryParams = new URLSearchParams();
    if (params.cropId) queryParams.append('cropId', params.cropId.toString());
    if (params.year) queryParams.append('year', params.year.toString());
    if (params.buyerName) queryParams.append('buyerName', params.buyerName);
    
    if (queryParams.toString()) {
      endpoint += `?${queryParams.toString()}`;
    }
  }

  try {
    return await getApi(endpoint);
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(`Failed to fetch contract prices: ${error.message}`);
    }
    throw new Error("Failed to get contract prices");
  }
};

export const putContractPriceApi = async (data: any) => {
  let endpoint = `ContractPrice/contractprices`;
  try {
    return await putApi(endpoint, data);
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      throw new Error(`${error.response?.data.error || error.message}`);
    }
    throw new Error("Failed to update contract price");
  }
};